<template>
    <v-navigation-drawer clipped class="grey lighten-5" app>
        <v-list>
            <v-subheader style="font-size: 24px">Funktionen</v-subheader>
            <v-list-item-group color="primary">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/"
                                >Übersicht neue Todos</router-link
                            >
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="myclient.add_meine_url">
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link :to="myclient.add_meine_url"
                                >Meine Todos</router-link
                            >
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <a href="/briefpapier/0">Blanko-Brief</a>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <a href="/versicherungen">Versicherungen</a>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/rummenigge"
                                >Rummenigge</router-link
                            >
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/johnny_walker"
                                >Johnny Walker</router-link
                            >
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/lorenz"
                                >da oide Lorenz</router-link
                            >
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>

        <v-list v-if="myclient.add_vm_rights">
            <v-subheader style="font-size: 24px">Vermittler</v-subheader>
            <v-list-item-group color="primary">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/vermittler/abrechnen"
                                >Vermittler abrechnen</router-link
                            >
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/allevermittler"
                                >Alle Vermittler</router-link
                            >
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/traffikant"
                                >Traffikant</router-link
                            >
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <router-link to="/cronboss">CronBoss</router-link>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: "NavDrawer",
    props: [],
    data() {
        return {
            dialog: false,
        };
    },
    methods: {
        changeRoute(route) {
            this.$router.push(route);
        },
    },
};
</script>
